/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuShapeSquare4Icon16Light } from './UiMenuShapeSquare4Icon16Light';
import { UiMenuShapeSquare4Icon16Regular } from './UiMenuShapeSquare4Icon16Regular';
import { UiMenuShapeSquare4Icon16Solid } from './UiMenuShapeSquare4Icon16Solid';
import { UiMenuShapeSquare4Icon20Light } from './UiMenuShapeSquare4Icon20Light';
import { UiMenuShapeSquare4Icon20Regular } from './UiMenuShapeSquare4Icon20Regular';
import { UiMenuShapeSquare4Icon20Solid } from './UiMenuShapeSquare4Icon20Solid';
import { UiMenuShapeSquare4Icon24Regular } from './UiMenuShapeSquare4Icon24Regular';
import { UiMenuShapeSquare4Icon24Solid } from './UiMenuShapeSquare4Icon24Solid';
import { UiMenuShapeSquare4Icon32Regular } from './UiMenuShapeSquare4Icon32Regular';
import { UiMenuShapeSquare4Icon64Regular } from './UiMenuShapeSquare4Icon64Regular';
var sizes = {
    16: {
        light: UiMenuShapeSquare4Icon16Light,
        regular: UiMenuShapeSquare4Icon16Regular,
        solid: UiMenuShapeSquare4Icon16Solid,
    },
    20: {
        light: UiMenuShapeSquare4Icon20Light,
        regular: UiMenuShapeSquare4Icon20Regular,
        solid: UiMenuShapeSquare4Icon20Solid,
    },
    24: {
        regular: UiMenuShapeSquare4Icon24Regular,
        solid: UiMenuShapeSquare4Icon24Solid,
    },
    32: {
        regular: UiMenuShapeSquare4Icon32Regular,
    },
    64: {
        regular: UiMenuShapeSquare4Icon64Regular,
    },
};
export var UiMenuShapeSquare4Icon = forwardRef('UiMenuShapeSquare4Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
